export default "__VITE_ASSET__f665b1ab__"